import { Text } from '@payaca/ambrosia';
import { FC } from 'react';

/**
 * Card title for the native design products: the brand name (Glow, Flow)
 * always paired with a plain-language descriptor, since installers meet these
 * names for the first time on this tab.
 */
export const BrandedCardTitle: FC<{ brand: string; descriptor: string }> = (
  props
) => {
  const { brand, descriptor } = props;
  return (
    <>
      {brand}{' '}
      <Text as="span" level="supporting">
        · {descriptor}
      </Text>
    </>
  );
};
